/* Opens the theme's existing product description without changing review apps. */
(() => {
  if (customElements.get('sudora-product-summary')) return;

  const isVisible = (element) => {
    if (!(element instanceof Element) || !element.isConnected || !element.getClientRects().length) return false;
    for (let current = element; current; current = current.parentElement) {
      const style = getComputedStyle(current);
      if (current.hidden || style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || Number(style.opacity) === 0) return false;
    }
    return true;
  };

  class SudoraProductSummary extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.productScope = this.closest('[data-section-type="product"]') || this.closest('.productView') || this.parentElement;
      this.addEventListener('click', (event) => this.handleClick(event), { signal: this.controller.signal });
      document.addEventListener('shopify:section:load', () => this.refresh(), { signal: this.controller.signal });
      this.refresh();
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.refresh(); });
    }

    disconnectedCallback() {
      this.controller?.abort();
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.controller = null;
    }

    descriptionChoice() {
      const target = this.productScope.querySelector('[data-sd-product-description]');
      if (!target) return null;
      const mobileLink = Array.from(target.querySelectorAll('a.toggleLink[href^="#tab-"]')).find(isVisible);
      const tabLink = Array.from(this.productScope.querySelectorAll('a[href^="#tab-"]')).find((link) => link.getAttribute('href') === `#${target.id}`);
      return { target, link: mobileLink || tabLink || null };
    }

    refresh() {
      if (!this.isConnected || !this.controller) return;
      this.querySelectorAll('[data-sd-product-details]').forEach((button) => {
        button.hidden = !this.descriptionChoice();
      });
    }

    handleClick(event) {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('[data-sd-product-details]');
      if (!button || !this.contains(button)) return;
      const choice = this.descriptionChoice();
      if (!choice) return;
      event.preventDefault();
      if (choice.link) {
        const popupMobile = choice.link.classList.contains('popup-mobile') && window.innerWidth <= 551;
        const popupContent = popupMobile ? choice.link.parentElement?.nextElementSibling : null;
        const alreadyOpen = popupMobile
          ? popupContent?.classList.contains('is-show')
          : choice.link.classList.contains('is-open') || choice.link.classList.contains('show-mobile');
        if (!alreadyOpen) choice.link.click();
      }
      if (this.frame) cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => {
        this.frame = 0;
        if (!this.isConnected || !choice.target.isConnected) return;
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        choice.target.scrollIntoView({ behavior, block: 'start' });
        if (!choice.target.hasAttribute('tabindex')) {
          choice.target.setAttribute('tabindex', '-1');
          choice.target.addEventListener('blur', () => choice.target.removeAttribute('tabindex'), { once: true });
        }
        choice.target.focus({ preventScroll: true });
      });
    }
  }

  customElements.define('sudora-product-summary', SudoraProductSummary);
})();
